<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import UserSettings from '../../../user/components/UserSettings.vue'

// The page is a developer time-zone demo; hidden for the 15 Oct release (web-50 UI-18)
definePage({
  redirect: '/user',
  meta: {
    requiresAuth: true,
    hideLeftColumn: true,
    hideRightColumn: true,
  },
})
</script>

<template>
  <UserSettings />
</template>
